import React from "react"
import { translate } from "react-i18next";
import { compose } from "recompose";
import { withRouter } from "react-router-dom";

function HorasReservaciones({
    tipoDeSala,
    horasDisponibles,
    horasUsadas,
    t
}) {
    let color = "var(--primary)"

    let total = 80;
    let porcentajeUsadasReal = 0;
    let porcentajeDisponiblesReal = 0;

    if (horasDisponibles > 0) {
        porcentajeUsadasReal = horasUsadas * total / horasDisponibles;
        porcentajeDisponiblesReal = total - porcentajeUsadasReal;
    }
    porcentajeUsadasReal = 100-porcentajeDisponiblesReal;

    if (porcentajeUsadasReal > total) {
        porcentajeUsadasReal = total;
        porcentajeDisponiblesReal = 20;
    }

    if (horasDisponibles === 0) {
        porcentajeDisponiblesReal = 50;
        porcentajeUsadasReal = 50;
    }
    if(tipoDeSala === "Horas Especiales de Salas Grandes" || tipoDeSala === "Horas de Salas Grandes" || tipoDeSala === "Special Hours of Large Rooms" || tipoDeSala === "Hours of Large Rooms"){
        color = "var(--secondary-alt)"
    }

    return (
        <div className="text-center">
            <span>{ tipoDeSala }</span><br />
            <div style={{ display: "flex", justifyContent: "space-around"}}>
                <span>{t('dashboard.reservations.label_available')}</span>
                <span>{t('dashboard.reservations.label_used')}</span>
            </div>
            <section className="progress">
                <div className="progress-bar" role="progressbar" aria-valuenow={ porcentajeDisponiblesReal } aria-valuemin="0" aria-valuemax="100" style={{ width: porcentajeDisponiblesReal + '%', backgroundColor: color }}>
                    <span>
                        { horasDisponibles }
                    </span>
                </div>
                <div className="progress-bar" role="progressbar" aria-valuenow={ porcentajeUsadasReal } aria-valuemin="0" aria-valuemax="100" style={{ width: porcentajeUsadasReal + '%', backgroundColor: "var(--dark-1)" }}>
                    { horasUsadas }
                </div>
            </section>
        </div>
    )
}

export default compose(translate("common"), withRouter)(HorasReservaciones);


// WEBPACK FOOTER //
// ./src/components/Balance/HorasReservaciones.jsx